<template>
  <section>
    <b-modal :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 15px;">
        <!-- 出品画面：ヘッダー -->
        <!-- ストアロボ全パーツ編集可能対応のためコメントアウト -->
        <!-- <div style="border-radius: 25px; background: #f2f2f2;">
          <div style="width: 100%; height: auto; padding: 15px; background: #AA0066; border-top-right-radius: 10px; border-top-left-radius: 10px; color: white;">
            <p><b>シナリオを初期作成時、編集できる箇所を選択してください（現在： {{selectScenarioList.length}} 個 選択中）</b></p>
          </div>
        </div> -->
        <!-- 出品画面：ボディ -->
        <div class="card-body">
          <div class="main-storeup">
            <div class="scenario-flow">
              <BluePrintStoreEdit ref="bp" class="blueprint"></BluePrintStoreEdit>
            </div>
          </div>
          <div style="width: 100%; margin-top: 10px; margin-bottom: 10px; margin-left: 20px; text-align: left;">
            <div style="display: flex; width: 100%;">
              <div style="display: flex; justify-content: center align-items: center; flex-direction: column;">
                <p>出品名</p>
                <input class="input" v-model="cbInfo.name"/>
              </div>
              <div style="display: flex; justify-content: center align-items: center; flex-direction: column; margin-left: 15px;">
                <p>出品カテゴリー</p>
                <b-select v-model="cbInfo.category">
                  <option v-for="(s, index) in storeCategory" :key="index" :value="s.category_id">{{s.category_name}}</option>
                </b-select>
              </div>
              <!-- <div style="display: flex; flex-direction: column; width: 100%;">
                <p>詳細説明</p><input class="input" v-model="storeItemDetail"/>
              </div> -->
            </div>
          </div>
          <div style="display: flex; justify-content: flex-start; align-items: center; width: 100%;">
            <div style="margin-left: 20px; margin-top: 10px; text-align: left;">
              <p style="font-size: 12px; color: #666;">※1.現在、試験運用中のため無料での出品となります。</p>
              <p style="font-size: 12px; color: #666;">※2.アイコン画像や文言はそのままのため、細心の注意を払って出品してください。</p>
              <p style="font-size: 12px; color: #666;">※3.実態にそぐわないカテゴリーの場合、予告なく変更することがございますのでご了承ください。</p>
              <p style="font-size: 12px; color: #666;">※4.画像表示のシナリオ、ロボ切替のシナリオについては初期化されます。</p>
            </div>
          </div>
          <hr>
          <!-- 出品画面：フッター -->
          <button class="button is-primary is-fullwidth" @click="uploadStoreItem(cbInfo)">変更する</button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import createUUID from '@/functions/createUUID'
import BluePrintStoreEdit from '@/views/DashBoard/ChatBot/BluePrintStoreEdit'
export default {
  name: 'ModalStoreUpload',
  components: {
    BluePrintStoreEdit
  },
  computed: {
    ...mapState('chatbot', ['chatbots', 'modalScenario', 'selectScenario', 'isSCNLoading', 'isDrop', 'scenarioTable', 'isIconLoading', 'isCBLoading', 'isFailedScenario', 'chatbotStatus', 'roboPartsSet', 'dropTemplate', 'selectChatbot', 'selectScenarioList']),
    ...mapState('auth', ['user', 'storeCategory'])
  },
  data () {
    return {
      newValue: '既存',
      cbInfo: {
        name: '',
        icon: '',
        target_url: '',
        scenario_name: '',
        created_at: '2019/4/1',
        parameter: {
          category: []
        }
      },
      selectedScenario: null,
      isCardModalActive: false,
      scenarioName: 'default',
      selectedName: 'No Name',
      storeItemName: '',
      storeItemCategory: '',
      storeItemDetail: '',
      inputs: {
        name: '',
        scenarioName: '',
        left: 0
      }
    }
  },
  watch: {
    isCardModalActive () {
      // this.$store.dispatch('chatbot/selectTemplate', {
      //   scenario_list: []
      // })
    }
  },
  methods: {
    uploadStoreItem (bot) {
      var cb = bot
      cb['name'] = bot.name
      cb['category'] = bot.category
      cb['select_scenario_list'] = this.selectScenarioList
      cb['scenario_list'] = this.scenarioTable
      cb['bot_id'] = bot.bot_id
      this.$store.dispatch('chatbot/updateChatBotStoreItem', cb)
      this.storeItemName = ''
      this.storeItemCategory = ''
      this.isCardModalActive = false
    },
    selectTemplate (selected) {
      this.selectedName = selected.name
      this.$store.dispatch('chatbot/selectTemplate', selected)
    }
  }
}
</script>

<style scoped>
.title-storeup {
  font-size: 20px;
  font-weight: 700;
  width: 100%;
  padding: 10px;
}
.main-storeup {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.card-body {
  background: #f2f2f2; 
  border-radius: 15px;
  padding: 15px;
  display: flex;
  justify-content: center; align-items: center; flex-direction: column;
  overflow-y: scroll;
}
.card-body::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.template-box {
  width: calc(50% - 10px);
  margin: 5px;
  padding: 10px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow-y: scroll;
}
.template-box::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.template-item {
  margin: 10px;
  padding: 5px;
  width: calc(50% - 20px);
  border-radius: 5px;
  background: white;
  word-break: break-word;
  transition: 0.5s;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.template-item:hover {
  transform: scale(1.05);
}
.scenario-flow {
  width: 100%;
  margin: 5px;
  height: 300px;
  position: relative;
  border: solid thin #ccc;
  background: white;
}
.scenario-setting {
  width: 70%;
  height: 300px;
  border: solid thin #ccc;
  background: white;
}
.official {
  font-size: 11.5px;
  margin-top: -5px;
  color: #777;
  display: flex;
  justify-content: center;
  border: solid thin #ccc;
  border-radius: 5px;
  line-height: 1.4;
}
.blueprint {
  height: 298px;
  width: 100%;
  overflow: scroll;
  display: block;
}
.blueprint::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.img-icon > img {
  display:    block;
  min-width:  75px;
  min-height: 75px;
  width:      75px;
  height:     75px;
  max-width:  75px;
  max-height: 75px;
  border-radius: 50%;
  object-fit: cover;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalStoreUploadEdit.vue